var _defs, _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStream(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 60,
    viewBox: "0 0 85 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#2450ff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 85,
    height: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M46.977,0A29.959,29.959,0,0,0,23.171,11.739H11.744a1.3,1.3,0,1,0,0,2.609h9.626a29.894,29.894,0,0,0-3.945,20.869H1.3a1.3,1.3,0,1,0,0,2.609h16.7a29.8,29.8,0,0,0,3.368,7.826H11.744a1.3,1.3,0,1,0,0,2.609H23.171A30.008,30.008,0,1,0,46.977,0ZM64.659,31.079,38.539,48.048a1.295,1.295,0,0,1-2-1.081V13.031a1.294,1.294,0,0,1,2-1.081L64.659,28.919a1.287,1.287,0,0,1,0,2.16Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.3,19.609H11.741a1.3,1.3,0,0,0,0-2.609H1.3a1.3,1.3,0,1,0,0,2.609Z",
    transform: "translate(0 5.173)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStream);
export default __webpack_public_path__ + "static/media/stream.103c772cc575e20142c99e908249b7fb.svg";
export { ForwardRef as ReactComponent };